export const createBlobPath = (content: string, type: string): string => {
	const utf8Encoded = '\uFEFF' + content;
	const blob: Blob = new Blob([utf8Encoded], { type });
	return window.URL.createObjectURL(blob);
};
